// extracted by mini-css-extract-plugin
export default {"result":"Results_result__mihPW","ratio":"Results_ratio__moGQV","label":"Results_label__O7pbW","value":"Results_value__UeLz9","start":"Results_start__vS+sv"};